var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.contacts),function(contact,idx){return _c('span',{key:contact.id},[_c('router-link',{attrs:{"to":_vm.$objectViewRoute(contact)}},[[_vm._v(" "+_vm._s(`${contact.firstname} ${contact.lastname} - ${ contact.zipcode ?? "" }`)+" "+_vm._s(_vm.contacts.length - 1 > idx ? "," : " ")),_c('br')]],2)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }